import { RegtankRequest } from "../types/org.type";

/**
 * Shared utility functions for Regtank operations
 */

/**
 * Sorts array by expiredDate descending (most recent first)
 * Generic function that works with any object containing expiredDate
 */
export const sortByExpiryDateDesc = <T extends { expiredDate: string | Date }>(
  items: T[]
): T[] => {
  return [...items].sort(
    (a, b) =>
      new Date(b.expiredDate).getTime() - new Date(a.expiredDate).getTime()
  );
};

/**
 * Converts Date or string to ISO string format
 */
export const toISOString = (date: string | Date | undefined): string => {
  if (!date) return "";
  return typeof date === "string" ? date : date.toISOString();
};

/**
 * Sorts data by expiredDate in descending order
 * Handles both string and Date object types
 */
export const sortRegtankRequestsByExpiry = (data: any[]): any[] => {
  const sorted = [...data];
  if (sorted.length === 0) return sorted;
  if (typeof sorted[0]?.expiredDate === "string") {
    return sorted.sort(
      (a, b) =>
        new Date(b.expiredDate).getTime() - new Date(a.expiredDate).getTime()
    );
  }
  return sorted.sort(
    (a, b) => b.expiredDate.getTime() - a.expiredDate.getTime()
  );
};
